let prefecturalList = {
  // 濮阳
  上蔡: {
    prod: {
      cityName: '上蔡县',
      deptId: '9214',
      backgroundImage: require('@/assets/images/shangcaixian.png'),
      reqBaseUrl: 'http://1.192.106.56:10003',
      // reqBaseUrl: "http://192.168.0.20:8087",
      linkList: [
        {
          name: '财务公开',
          url: 'http://117.159.15.238:16036',
          src: require('@/assets/images/sjfx.png'),
          backGround: require('../assets/images/bg_sjfx.png'),
        },
        {
          name: '财务管理',
          url: 'http://1.192.106.56:10009/login?redirect=/index&ssoUrl=http://117.159.15.238:16038',
          src: require('@/assets/images/cwgl.png'),
          backGround: require('../assets/images/bg_cwgl.png'),
        },
        {
          name: '产权交易',
          url: 'http://117.159.15.238:16059',
          // url: "http://117.159.15.238:16020?ssoUrl=http://117.159.15.238:16038",
          src: require('@/assets/images/jygl.png'),
          backGround: require('@/assets/images/bg_jygl.png'),
        },
        {
          name: '网报支付',
          url: 'http://117.159.15.238:16072/login?redirect=/index&ssoUrl=http://117.159.15.238:16038',
          src: require('@/assets/images/wbzf.png'),
          backGround: require('@/assets/images/bg_wbzf.png'),
        },
        {
          name: '合同管理',
          url: 'http://117.159.15.238:16021/login?redirect=/index&ssoUrl=http://117.159.15.238:16038',
          src: require('@/assets/images/htgl.png'),
          backGround: require('@/assets/images/bg_htgl.png'),
          children: '/HMXX',
        },
        {
          name: '新型经营主体',
          url: 'http://117.159.15.238:16043/login?redirect=/index&ssoUrl=http://117.159.15.238:16076',
          src: require('@/assets/images/xxjyzt.png'),
          backGround: require('@/assets/images/bg_xxjyzt.png'),
        },
        {
          name: '土地承包网签',
          url: 'http://117.159.15.238:15063/#/login',
          src: require('@/assets/images/tdcbwq.png'),
          backGround: require('@/assets/images/bg_tdcbwq.png'),
        },
        {
          name: '确权变更',
          url: 'http://117.159.15.238:15062/#/login',
          src: require('@/assets/images/qqbg.png'),
          backGround: require('@/assets/images/bg_qqbg.png'),
        },
        {
          name: '预警监测',
          url: 'http://117.159.15.238:16058/',
          src: require('@/assets/images/yjjc.png'),
          backGround: require('@/assets/images/bg_yjjc.png'),
          children: '/HMXX',
        },
      ],
    },
    dev: {},
  },
  //濮阳
  范县: {
    prod: {
      cityName: '范县',
      deptId: '5290',
      backgroundImage: require('@/assets/images/fanxian.png'),
      reqBaseUrl: 'http://1.192.106.51:10003',
      linkList: [
        {
          name: '财务公开',
          url: 'http://117.159.15.238:16169',
          src: require('@/assets/images/sjfx.png'),
          backGround: require('../assets/images/bg_sjfx.png'),
        },
        {
          name: '财务管理',
          url: 'http://1.192.106.56:10009?redirect=/index&ssoUrl=http://117.159.15.238:16171',
          src: require('@/assets/images/cwgl.png'),
          backGround: require('../assets/images/bg_cwgl.png'),
        },
        {
          name: '产权交易',
          url: 'http://117.159.15.238:16172',
          src: require('@/assets/images/jygl.png'),
          backGround: require('@/assets/images/bg_jygl.png'),
        },
        {
          name: '网报支付',
          url: 'http://117.159.15.238:16023?redirect=/index&ssoUrl=http://117.159.15.238:16171',
          src: require('@/assets/images/wbzf.png'),
          backGround: require('@/assets/images/bg_wbzf.png'),
        },
        {
          name: '合同管理',
          url: 'http://117.159.15.238:16021?redirect=/index&ssoUrl=http://117.159.15.238:16171',
          src: require('@/assets/images/htgl.png'),
          backGround: require('@/assets/images/bg_htgl.png'),
        },
        {
          name: '新型经营主体',
          url: 'http://117.159.15.238:16043?redirect=/index&ssoUrl=http://117.159.15.238:16171',
          src: require('@/assets/images/xxjyzt.png'),
          backGround: require('@/assets/images/bg_xxjyzt.png'),
        },
        {
          name: '土地改错',
          url: 'http://117.159.15.238:16170?redirect=/index&ssoUrl=http://117.159.15.238:16171',
          src: require('@/assets/images/qqbg.png'),
          backGround: require('@/assets/images/bg_qqbg.png'),
        },
        {
          name: '预警监测',
          url: 'http://117.159.15.238:16168',
          src: require('@/assets/images/yjjc.png'),
          backGround: require('@/assets/images/bg_yjjc.png'),
        },
      ],
      showAppImage: true,
      appImage: require('@/assets/images/fanxianAppImage.png'),
    },
    dev: {},
  },
  //濮阳
  南乐: {
    prod: {
      cityName: '南乐县',
      deptId: '5289',
      backgroundImage: require('@/assets/images/fanxian.png'),
      reqBaseUrl: 'http://1.192.106.51:10003',
      linkList: [
        {
          name: '阳光决策',
          url: 'http://1.192.106.56:10011?redirect=/index&ssoUrl=http://117.159.15.238:18019',
          src: require('@/assets/images/gqgl.png'),
          backGround: require('../assets/images/bg_sjfx.png'),
        },
        {
          name: '财务管理',
          url: 'http://1.192.106.56:10009?redirect=/index&ssoUrl=http://117.159.15.238:18019',
          src: require('@/assets/images/cwgl.png'),
          backGround: require('../assets/images/bg_cwgl.png'),
        },
        {
          name: '阳光公开',
          url: 'http://117.159.15.238:18026',
          src: require('@/assets/images/sjfx.png'),
          backGround: require('../assets/images/bg_sjfx.png'),
        },
        {
          name: '网报支付',
          url: 'http://117.159.15.238:16023?redirect=/index&ssoUrl=http://117.159.15.238:18019',
          src: require('@/assets/images/wbzf.png'),
          backGround: require('@/assets/images/bg_wbzf.png'),
        },
        {
          name: '合同管理',
          url: 'http://117.159.15.238:16021?redirect=/index&ssoUrl=http://117.159.15.238:18019',
          src: require('@/assets/images/htgl.png'),
          backGround: require('@/assets/images/bg_htgl.png'),
        },
        {
          name: '监督预警',
          url: 'http://117.159.15.238:18022',
          src: require('@/assets/images/yjjc.png'),
          backGround: require('@/assets/images/bg_yjjc.png'),
        },
        {
          name: '产权交易',
          url: 'http://117.159.15.238:18028',
          src: require('@/assets/images/jygl.png'),
          backGround: require('@/assets/images/bg_jygl.png'),
        },
      ],
      showAppImage: true,
      appImage: require('@/assets/images/nanleAppImage.png'),
    },
    dev: {},
  },
  //濮阳
  清丰: {
    prod: {
      cityName: '清丰县',
      deptId: '5288',
      backgroundImage: require('@/assets/images/fanxian.png'),
      reqBaseUrl: 'http://1.192.106.51:10003',
      linkList: [
        {
          name: '阳光决策',
          url: 'http://1.192.106.56:10011?redirect=/index&ssoUrl=http://117.159.15.238:18020',
          src: require('@/assets/images/gqgl.png'),
          backGround: require('../assets/images/bg_sjfx.png'),
        },
        {
          name: '财务管理',
          url: 'http://1.192.106.56:10009?redirect=/index&ssoUrl=http://117.159.15.238:18020',
          src: require('@/assets/images/cwgl.png'),
          backGround: require('../assets/images/bg_cwgl.png'),
        },
        {
          name: '阳光公开',
          url: 'http://117.159.15.238:16132',
          src: require('@/assets/images/sjfx.png'),
          backGround: require('../assets/images/bg_sjfx.png'),
        },
        {
          name: '网报支付',
          url: 'http://117.159.15.238:16023?redirect=/index&ssoUrl=http://117.159.15.238:18020',
          src: require('@/assets/images/wbzf.png'),
          backGround: require('@/assets/images/bg_wbzf.png'),
        },
        {
          name: '合同管理',
          url: 'http://117.159.15.238:16021?redirect=/index&ssoUrl=http://117.159.15.238:18020',
          src: require('@/assets/images/htgl.png'),
          backGround: require('@/assets/images/bg_htgl.png'),
        },
        {
          name: '监督预警',
          url: 'http://117.159.15.238:18024',
          src: require('@/assets/images/yjjc.png'),
          backGround: require('@/assets/images/bg_yjjc.png'),
        },
        {
          name: '产权交易',
          url: 'http://117.159.15.238:16133',
          src: require('@/assets/images/jygl.png'),
          backGround: require('@/assets/images/bg_jygl.png'),
        },
        {
          name: '土地改错',
          url: 'http://117.159.15.238:16170?redirect=/index&ssoUrl=http://117.159.15.238:18020',
          src: require('@/assets/images/qqbg.png'),
          backGround: require('@/assets/images/bg_qqbg.png'),
        },
        {
          name: '新型经营主体',
          url: 'http://117.159.15.238:16043?redirect=/index&ssoUrl=http://117.159.15.238:18020',
          src: require('@/assets/images/xxjyzt.png'),
          backGround: require('@/assets/images/bg_xxjyzt.png'),
        },
      ],
      showAppImage: true,
      appImage: require('@/assets/images/qingfengAppImage.png'),
    },
    dev: {},
  },
  //濮阳
  台前: {
    prod: {
      cityName: '台前县',
      deptId: '5291',
      backgroundImage: require('@/assets/images/fanxian.png'),
      reqBaseUrl: 'http://1.192.106.51:10003',
      linkList: [
        {
          name: '阳光决策',
          url: 'http://1.192.106.56:10011?redirect=/index&ssoUrl=http://117.159.15.238:18021',
          src: require('@/assets/images/gqgl.png'),
          backGround: require('../assets/images/bg_sjfx.png'),
        },
        {
          name: '财务管理',
          url: 'http://1.192.106.56:10009?redirect=/index&ssoUrl=http://117.159.15.238:18021',
          src: require('@/assets/images/cwgl.png'),
          backGround: require('../assets/images/bg_cwgl.png'),
        },
        {
          name: '阳光公开',
          url: 'http://117.159.15.238:18025',
          src: require('@/assets/images/sjfx.png'),
          backGround: require('../assets/images/bg_sjfx.png'),
        },
        {
          name: '网报支付',
          url: 'http://117.159.15.238:16023?redirect=/index&ssoUrl=http://117.159.15.238:18021',
          src: require('@/assets/images/wbzf.png'),
          backGround: require('@/assets/images/bg_wbzf.png'),
        },
        {
          name: '合同管理',
          url: 'http://117.159.15.238:16021?redirect=/index&ssoUrl=http://117.159.15.238:18021',
          src: require('@/assets/images/htgl.png'),
          backGround: require('@/assets/images/bg_htgl.png'),
        },
        {
          name: '监督预警',
          url: 'http://117.159.15.238:18023',
          src: require('@/assets/images/yjjc.png'),
          backGround: require('@/assets/images/bg_yjjc.png'),
        },
        {
          name: '产权交易',
          url: 'http://117.159.15.238:18027',
          src: require('@/assets/images/jygl.png'),
          backGround: require('@/assets/images/bg_jygl.png'),
        },
      ],
      showAppImage: true,
      appImage: require('@/assets/images/taiqianAppImage.png'),
    },
    dev: {},
  },
  //濮阳
  濮阳县: {
    prod: {
      cityName: '濮阳县',
      homeTitle: '“四议两公开”阳光决策数智平台',
      deptId: '5292',
      backgroundImage: require('@/assets/images/fanxian.png'),
      reqBaseUrl: 'http://1.192.106.51:10003',
      linkList: [
        {
          name: '阳光决策',
          url: 'http://1.192.106.56:10011?redirect=/index&ssoUrl=http://117.159.15.238:18038',
          src: require('@/assets/images/gqgl.png'),
          backGround: require('../assets/images/bg_sjfx.png'),
        },
        {
          name: '财务管理',
          url: 'http://1.192.106.56:10009?redirect=/index&ssoUrl=http://117.159.15.238:18038',
          src: require('@/assets/images/cwgl.png'),
          backGround: require('../assets/images/bg_cwgl.png'),
        },
        {
          name: '阳光公开',
          url: 'http://117.159.15.238:18041',
          src: require('@/assets/images/sjfx.png'),
          backGround: require('../assets/images/bg_sjfx.png'),
        },
        {
          name: '网报支付',
          url: 'http://117.159.15.238:16023?redirect=/index&ssoUrl=http://117.159.15.238:18038',
          src: require('@/assets/images/wbzf.png'),
          backGround: require('@/assets/images/bg_wbzf.png'),
        },
        {
          name: '合同管理',
          url: 'http://117.159.15.238:16021?redirect=/index&ssoUrl=http://117.159.15.238:18038',
          src: require('@/assets/images/htgl.png'),
          backGround: require('@/assets/images/bg_htgl.png'),
        },
        {
          name: '监督预警',
          url: 'http://117.159.15.238:18040',
          src: require('@/assets/images/yjjc.png'),
          backGround: require('@/assets/images/bg_yjjc.png'),
        },
        {
          name: '产权交易',
          url: 'http://117.159.15.238:18039',
          src: require('@/assets/images/jygl.png'),
          backGround: require('@/assets/images/bg_jygl.png'),
        },
      ],
      showAppImage: true,
      appImage: require('@/assets/images/puyangxianAppImage.png'),
    },
    dev: {},
  },
  //濮阳
  濮阳市城乡一体化示范区: {
    prod: {
      cityName: '濮阳市城乡一体化示范区',
      deptId: '58110',
      backgroundImage: require('@/assets/images/fanxian.png'),
      reqBaseUrl: 'http://1.192.106.51:10003',
      linkList: [
        {
          name: '阳光决策',
          url: 'http://1.192.106.56:10011?redirect=/index&ssoUrl=http://117.159.15.238:16010',
          src: require('@/assets/images/gqgl.png'),
          backGround: require('../assets/images/bg_sjfx.png'),
        },
        {
          name: '财务管理',
          url: 'http://1.192.106.56:10009?redirect=/index&ssoUrl=http://117.159.15.238:16010',
          src: require('@/assets/images/cwgl.png'),
          backGround: require('../assets/images/bg_cwgl.png'),
        },
        {
          name: '阳光公开',
          url: 'http://117.159.15.238:16159',
          src: require('@/assets/images/sjfx.png'),
          backGround: require('../assets/images/bg_sjfx.png'),
        },
        {
          name: '网报支付',
          url: 'http://117.159.15.238:16023?redirect=/index&ssoUrl=http://117.159.15.238:16010',
          src: require('@/assets/images/wbzf.png'),
          backGround: require('@/assets/images/bg_wbzf.png'),
        },
        {
          name: '合同管理',
          url: 'http://117.159.15.238:16021?redirect=/index&ssoUrl=http://117.159.15.238:16010',
          src: require('@/assets/images/htgl.png'),
          backGround: require('@/assets/images/bg_htgl.png'),
        },
        {
          name: '监督预警',
          url: 'http://117.159.15.238:16158',
          src: require('@/assets/images/yjjc.png'),
          backGround: require('@/assets/images/bg_yjjc.png'),
        },
        {
          name: '产权交易',
          url: 'http://117.159.15.238:16160',
          src: require('@/assets/images/jygl.png'),
          backGround: require('@/assets/images/bg_jygl.png'),
        },
      ],
      showAppImage: true,
      appImage: require('@/assets/images/puyangshiyitihuashifanquAppImage.png'),
      footList: [
        { text: '主管部门:濮阳市城乡一体化示范区农业发展服务中心' },
        { text: '监督部门:濮阳市城乡一体化示范区纪委监委' },
        { text: '技术单位:河南晟宇信息技术有限公司' },
      ],
    },
    dev: {},
  },
  //濮阳
  濮阳工业区: {
    prod: {
      cityName: '濮阳工业区',
      deptId: '5293',
      backgroundImage: require('@/assets/images/fanxian.png'),
      reqBaseUrl: 'http://1.192.106.51:10003',
      linkList: [
        {
          name: '阳光决策',
          url: 'http://1.192.106.56:10011?redirect=/index&ssoUrl=http://117.159.15.238:18035',
          src: require('@/assets/images/gqgl.png'),
          backGround: require('../assets/images/bg_sjfx.png'),
        },
        {
          name: '财务管理',
          url: 'http://1.192.106.56:10009?redirect=/index&ssoUrl=http://117.159.15.238:18035',
          src: require('@/assets/images/cwgl.png'),
          backGround: require('../assets/images/bg_cwgl.png'),
        },
        {
          name: '阳光公开',
          url: 'http://117.159.15.238:18033',
          src: require('@/assets/images/sjfx.png'),
          backGround: require('../assets/images/bg_sjfx.png'),
        },
        {
          name: '网报支付',
          url: 'http://117.159.15.238:16023?redirect=/index&ssoUrl=http://117.159.15.238:18035',
          src: require('@/assets/images/wbzf.png'),
          backGround: require('@/assets/images/bg_wbzf.png'),
        },
        {
          name: '合同管理',
          url: 'http://117.159.15.238:16021?redirect=/index&ssoUrl=http://117.159.15.238:18035',
          src: require('@/assets/images/htgl.png'),
          backGround: require('@/assets/images/bg_htgl.png'),
        },
        {
          name: '监督预警',
          url: 'http://117.159.15.238:18034',
          src: require('@/assets/images/yjjc.png'),
          backGround: require('@/assets/images/bg_yjjc.png'),
        },
        {
          name: '产权交易',
          url: 'http://117.159.15.238:18032',
          src: require('@/assets/images/jygl.png'),
          backGround: require('@/assets/images/bg_jygl.png'),
        },
      ],
      showAppImage: true,
      appImage: require('@/assets/images/puyanggongyequAppImage.png'),
    },
    dev: {},
  },
  // 三门峡
  卢氏: {
    prod: {
      cityName: '卢氏县',
      homeTitle: '农村集体“三资”智慧化监管平台',
      deptId: '1649',
      backgroundImage: require('@/assets/images/lushixian.png'),
      reqBaseUrl: 'http://1.192.106.51:10003',
      // reqBaseUrl: "http://192.168.0.20:8087",
      linkList: [
        {
          name: '财务公开',
          url: 'http://117.159.15.238:16139',
          src: require('@/assets/images/sjfx.png'),
          backGround: require('../assets/images/bg_sjfx.png'),
        },
        {
          name: '财务管理',
          url: 'http://1.192.106.51:10012?redirect=/index&ssoUrl=http://117.159.15.238:16151',
          src: require('@/assets/images/cwgl.png'),
          backGround: require('../assets/images/bg_cwgl.png'),
        },
        {
          name: '产权交易',
          url: 'http://117.159.15.238:16161/',
          src: require('@/assets/images/jygl.png'),
          backGround: require('@/assets/images/bg_jygl.png'),
        },
        {
          name: '网报支付',
          url: 'http://61.158.162.179:10005?redirect=/index&ssoUrl=http://117.159.15.238:16151',
          src: require('@/assets/images/wbzf.png'),
          backGround: require('@/assets/images/bg_wbzf.png'),
        },
        {
          name: '四议两公开云上会议',
          url: 'http://117.159.15.238:18015?redirect=/index&ssoUrl=http://117.159.15.238:16151',
          src: require('@/assets/images/gqgl.png'),
          backGround: require('@/assets/images/bg_htgl.png'),
        },
        {
          name: '合同管理',
          url: 'http://117.159.15.238:16157?redirect=/index&ssoUrl=http://117.159.15.238:16151',
          src: require('@/assets/images/htgl.png'),
          backGround: require('@/assets/images/bg_htgl.png'),
        },
        {
          name: '新型经营主体',
          url: 'http://117.159.15.238:16155?redirect=/index&ssoUrl=http://117.159.15.238:16151',
          src: require('@/assets/images/xxjyzt.png'),
          backGround: require('@/assets/images/bg_xxjyzt.png'),
        },
        {
          name: '土地改错',
          url: 'http://117.159.15.238:16165?redirect=/index&ssoUrl=http://117.159.15.238:16151',
          src: require('@/assets/images/qqbg.png'),
          backGround: require('@/assets/images/bg_qqbg.png'),
        },
        {
          name: '预警监测',
          url: 'http://117.159.15.238:16150',
          src: require('@/assets/images/yjjc.png'),
          backGround: require('@/assets/images/bg_yjjc.png'),
        },
      ],
      showAppImage: true,
      appImage: require('@/assets/images/lushiAppImage.png'),
      keepShowAppImage: true,
    },
    dev: {},
  },
  // 三门峡
  灵宝: {
    prod: {
      cityName: '灵宝市',
      homeTitle: '农村集体“三资”智慧化监管平台',
      deptId: '1651',
      backgroundImage: require('@/assets/images/lingbao.png'),
      reqBaseUrl: 'http://1.192.106.51:10003',
      // reqBaseUrl: "http://192.168.0.20:8087",
      footList: [
        { text: '主管部门:灵宝市农业农村局' },
        { text: '监督部门:灵宝市纪委监委' },
        { text: '技术单位:河南晟宇信息技术有限公司' },
        { text: '合作单位:河南农商银行灵宝支行' },
      ],
      linkList: [
        {
          name: '财务公开',
          url: 'http://117.159.15.238:18005',
          src: require('@/assets/images/sjfx.png'),
          backGround: require('../assets/images/bg_sjfx.png'),
        },
        {
          name: '财务管理',
          url: 'http://1.192.106.51:10012?redirect=/index&ssoUrl=http://117.159.15.238:18004',
          src: require('@/assets/images/cwgl.png'),
          backGround: require('../assets/images/bg_cwgl.png'),
        },
        {
          name: '产权交易',
          url: 'http://117.159.15.238:18007',
          src: require('@/assets/images/jygl.png'),
          backGround: require('@/assets/images/bg_jygl.png'),
        },
        {
          name: '网报支付',
          url: 'http://61.158.162.179:10005?redirect=/index&ssoUrl=http://117.159.15.238:18004',
          src: require('@/assets/images/wbzf.png'),
          backGround: require('@/assets/images/bg_wbzf.png'),
        },
        {
          name: '四议两公开云上会议',
          url: 'http://117.159.15.238:18015?redirect=/index&ssoUrl=http://117.159.15.238:18004',
          src: require('@/assets/images/gqgl.png'),
          backGround: require('@/assets/images/bg_htgl.png'),
        },
        {
          name: '合同管理',
          url: 'http://117.159.15.238:16157?redirect=/index&ssoUrl=http://117.159.15.238:18004',
          src: require('@/assets/images/htgl.png'),
          backGround: require('@/assets/images/bg_htgl.png'),
        },
        {
          name: '新型经营主体',
          url: 'http://117.159.15.238:16155?redirect=/index&ssoUrl=http://117.159.15.238:18004',
          src: require('@/assets/images/xxjyzt.png'),
          backGround: require('@/assets/images/bg_xxjyzt.png'),
        },
        {
          name: '土地改错',
          url: 'http://117.159.15.238:16165?redirect=/index&ssoUrl=http://117.159.15.238:18004',
          src: require('@/assets/images/qqbg.png'),
          backGround: require('@/assets/images/bg_qqbg.png'),
        },
        {
          name: '预警监测',
          url: 'http://117.159.15.238:18006',
          src: require('@/assets/images/yjjc.png'),
          backGround: require('@/assets/images/bg_yjjc.png'),
        },
      ],
      showAppImage: true,
      appImage: require('@/assets/images/lingbaoAppImage.png'),
    },
    dev: {},
  },
  // 三门峡
  湖滨: {
    prod: {
      cityName: '湖滨区',
      homeTitle: '农村集体“三资”智慧化监管平台',
      deptId: '1646',
      backgroundImage: require('@/assets/images/hubin.png'),
      reqBaseUrl: 'http://1.192.106.51:10003',
      // reqBaseUrl: "http://192.168.0.20:8087",
      linkList: [
        {
          name: '财务公开',
          url: 'http://117.159.15.238:16187',
          src: require('@/assets/images/sjfx.png'),
          backGround: require('../assets/images/bg_sjfx.png'),
        },
        {
          name: '财务管理',
          url: 'http://1.192.106.51:10012?redirect=/index&ssoUrl=http://117.159.15.238:16190',
          src: require('@/assets/images/cwgl.png'),
          backGround: require('../assets/images/bg_cwgl.png'),
        },
        {
          name: '产权交易',
          url: 'http://117.159.15.238:16189',
          src: require('@/assets/images/jygl.png'),
          backGround: require('@/assets/images/bg_jygl.png'),
        },
        {
          name: '网报支付',
          url: 'http://61.158.162.179:10005?redirect=/index&ssoUrl=http://117.159.15.238:16190',
          src: require('@/assets/images/wbzf.png'),
          backGround: require('@/assets/images/bg_wbzf.png'),
        },
        {
          name: '四议两公开云上会议',
          url: 'http://117.159.15.238:18015?redirect=/index&ssoUrl=http://117.159.15.238:16190',
          src: require('@/assets/images/gqgl.png'),
          backGround: require('@/assets/images/bg_htgl.png'),
        },
        {
          name: '合同管理',
          url: 'http://117.159.15.238:16157?redirect=/index&ssoUrl=http://117.159.15.238:16190',
          src: require('@/assets/images/htgl.png'),
          backGround: require('@/assets/images/bg_htgl.png'),
        },
        {
          name: '新型经营主体',
          url: 'http://117.159.15.238:16155?redirect=/index&ssoUrl=http://117.159.15.238:16190',
          src: require('@/assets/images/xxjyzt.png'),
          backGround: require('@/assets/images/bg_xxjyzt.png'),
        },
        {
          name: '土地改错',
          url: 'http://117.159.15.238:16165?redirect=/index&ssoUrl=http://117.159.15.238:16190',
          src: require('@/assets/images/qqbg.png'),
          backGround: require('@/assets/images/bg_qqbg.png'),
        },
        {
          name: '预警监测',
          url: 'http://117.159.15.238:16188',
          src: require('@/assets/images/yjjc.png'),
          backGround: require('@/assets/images/bg_yjjc.png'),
        },
      ],
      showAppImage: true,
      appImage: require('@/assets/images/hubinAppImage.png'),
    },
    dev: {},
  },
  // 三门峡
  郾城: {
    prod: {
      cityName: '郾城区',
      deptId: '1641',
      backgroundImage: require('@/assets/images/henan.png'),
      reqBaseUrl: 'http://1.192.106.56:10003',
      linkList: [
        {
          name: '财务公开',
          url: 'http://117.159.15.238:16014',
          src: require('@/assets/images/sjfx.png'),
          backGround: require('../assets/images/bg_sjfx.png'),
        },
        {
          name: '财务管理',
          url: 'http://1.192.106.56:10009?redirect=/index&ssoUrl=http://117.159.15.238:16013',
          src: require('@/assets/images/cwgl.png'),
          backGround: require('../assets/images/bg_cwgl.png'),
        },
        {
          name: '产权交易',
          url: 'http://117.159.15.238:16193',
          src: require('@/assets/images/jygl.png'),
          backGround: require('@/assets/images/bg_jygl.png'),
        },
        {
          name: '网报支付',
          url: 'http://117.159.15.238:16023?redirect=/index&ssoUrl=http://117.159.15.238:16013',
          src: require('@/assets/images/wbzf.png'),
          backGround: require('@/assets/images/bg_wbzf.png'),
        },
        {
          name: '合同管理',
          url: 'http://117.159.15.238:16021?redirect=/index&ssoUrl=http://117.159.15.238:16013',
          src: require('@/assets/images/htgl.png'),
          backGround: require('@/assets/images/bg_htgl.png'),
        },
        {
          name: '新型经营主体',
          url: 'http://117.159.15.238:16043?redirect=/index&ssoUrl=http://117.159.15.238:16013',
          src: require('@/assets/images/xxjyzt.png'),
          backGround: require('@/assets/images/bg_xxjyzt.png'),
        },
        {
          name: '土地改错',
          url: 'http://117.159.15.238:16170?redirect=/index&ssoUrl=http://117.159.15.238:16013',
          src: require('@/assets/images/qqbg.png'),
          backGround: require('@/assets/images/bg_qqbg.png'),
        },
        {
          name: '预警监测',
          url: 'http://117.159.15.238:16192',
          src: require('@/assets/images/yjjc.png'),
          backGround: require('@/assets/images/bg_yjjc.png'),
        },
      ],
      showAppImage: true,
      appImage: require('@/assets/images/yanchengAppImage.png'),
    },
    dev: {},
  },
  // 三门峡
  陕州: {
    prod: {
      cityName: '陕州区',
      deptId: '1648',
      homeTitle: '农村集体“三资”智慧化监管平台',
      backgroundImage: require('@/assets/images/shanzhou.png'),
      reqBaseUrl: 'http://1.192.106.51:10003',
      linkList: [
        {
          name: '财务公开',
          url: 'http://117.159.15.238:16195',
          src: require('@/assets/images/sjfx.png'),
          backGround: require('../assets/images/bg_sjfx.png'),
        },
        {
          name: '财务管理',
          url: 'http://1.192.106.51:10012?redirect=/index&ssoUrl=http://117.159.15.238:16197',
          src: require('@/assets/images/cwgl.png'),
          backGround: require('../assets/images/bg_cwgl.png'),
        },
        {
          name: '产权交易',
          url: 'http://117.159.15.238:16198',
          src: require('@/assets/images/jygl.png'),
          backGround: require('@/assets/images/bg_jygl.png'),
        },
        {
          name: '网报支付',
          url: 'http://61.158.162.179:10005?redirect=/index&ssoUrl=http://117.159.15.238:16197',
          src: require('@/assets/images/wbzf.png'),
          backGround: require('@/assets/images/bg_wbzf.png'),
        },
        {
          name: '四议两公开云上会议',
          url: 'http://117.159.15.238:18015?redirect=/index&ssoUrl=http://117.159.15.238:16197',
          src: require('@/assets/images/gqgl.png'),
          backGround: require('@/assets/images/bg_htgl.png'),
        },
        {
          name: '合同管理',
          url: 'http://117.159.15.238:16157?redirect=/index&ssoUrl=http://117.159.15.238:16197',
          src: require('@/assets/images/htgl.png'),
          backGround: require('@/assets/images/bg_htgl.png'),
        },
        {
          name: '新型经营主体',
          url: 'http://117.159.15.238:16155?redirect=/index&ssoUrl=http://117.159.15.238:16197',
          src: require('@/assets/images/xxjyzt.png'),
          backGround: require('@/assets/images/bg_xxjyzt.png'),
        },
        {
          name: '土地改错',
          url: 'http://117.159.15.238:16165?redirect=/index&ssoUrl=http://117.159.15.238:16197',
          src: require('@/assets/images/qqbg.png'),
          backGround: require('@/assets/images/bg_qqbg.png'),
        },
        {
          name: '预警监测',
          url: 'http://117.159.15.238:16196',
          src: require('@/assets/images/yjjc.png'),
          backGround: require('@/assets/images/bg_yjjc.png'),
        },
      ],
      showAppImage: true,
      appImage: require('@/assets/images/shanzhouAppImage.png'),
    },
    dev: {},
  },
  // 三门峡
  三门峡: {
    prod: {
      cityName: '三门峡市',
      deptId: '',
      backgroundImage: require('@/assets/images/sanmenxia.png'),
      reqBaseUrl: 'http://1.192.106.56:10003',
      linkList: [
        {
          name: '卢氏县',
          url: 'http://117.159.15.238:16152',
          src: require('@/assets/images/sanmenxia/icon1.png'),
          backGround: require('../assets/images/sanmenxia/backIcon.png'),
        },
        {
          name: '灵宝市',
          url: 'http://117.159.15.238:18008',
          src: require('@/assets/images/sanmenxia/icon2.png'),
          backGround: require('../assets/images/sanmenxia/backIcon.png'),
        },
        {
          name: '陕州区',
          url: 'http://117.159.15.238:16199',
          src: require('@/assets/images/sanmenxia/icon3.png'),
          backGround: require('@/assets/images/sanmenxia/backIcon.png'),
        },
        {
          name: '示范区',
          url: 'http://smxsfqncsz.cn:8850/#/default',
          src: require('@/assets/images/sanmenxia/icon4.png'),
          backGround: require('@/assets/images/sanmenxia/backIcon.png'),
        },
        {
          name: '湖滨区',
          url: 'http://117.159.15.238:16191',
          src: require('@/assets/images/sanmenxia/icon5.png'),
          backGround: require('@/assets/images/sanmenxia/backIcon.png'),
        },
        {
          name: '渑池县',
          url: 'http://218.29.151.10:8850/#/default',
          src: require('@/assets/images/sanmenxia/icon6.png'),
          backGround: require('@/assets/images/sanmenxia/backIcon.png'),
        },
      ],
      notShowCqjyDetail: true,
      footList: [
        {
          text: '主管部门:三门峡市农业农村局',
        },
        {
          text: '监督部门:三门峡市纪委监委',
        },
      ],
    },
    dev: {},
  },
  //
  郑州航空港区: {
    prod: {
      cityName: '郑州航空港区',
      homeTitle: '农村集体财产监督管理平台',
      deptId: '3761',
      backgroundImage: require('@/assets/images/bj_HKG.png'),
      reqBaseUrl: 'http://1.192.106.51:10003',
      footList: [
        { text: '主管部门:郑州航空港区农业农村局' },
        { text: '监督部门:郑州航空港区纪委监委' },
        { text: '技术单位:河南晟宇信息技术有限公司' },
        // { text: "合作单位:河南农商银行灵宝支行" },
      ],
      linkList: [
        {
          name: '财务公开',
          url: 'http://117.159.15.238:18012',
          src: require('@/assets/images/sjfx.png'),
          backGround: require('../assets/images/bg_sjfx.png'),
        },
        {
          name: '财务管理',
          url: 'http://1.92.70.79:10012?redirect=/index&ssoUrl=http://117.159.15.238:18011',
          src: require('@/assets/images/cwgl.png'),
          backGround: require('../assets/images/bg_cwgl.png'),
        },
        {
          name: '产权交易',
          url: 'http://117.159.15.238:18014',
          src: require('@/assets/images/jygl.png'),
          backGround: require('@/assets/images/bg_jygl.png'),
        },
        {
          name: '网报支付',
          url: 'http://1.92.70.79:10015?redirect=/index&ssoUrl=http://117.159.15.238:18011',
          src: require('@/assets/images/wbzf.png'),
          backGround: require('@/assets/images/bg_wbzf.png'),
        },
        {
          name: '四议两公开云上会议',
          url: 'http://1.92.70.79:10077?redirect=/index&ssoUrl=http://117.159.15.238:18011',
          src: require('@/assets/images/gqgl.png'),
          backGround: require('@/assets/images/bg_htgl.png'),
        },
        {
          name: '合同管理',
          url: 'http://1.92.70.79:10017?redirect=/index&ssoUrl=http://117.159.15.238:18011',
          src: require('@/assets/images/htgl.png'),
          backGround: require('@/assets/images/bg_htgl.png'),
        },
        {
          name: '新型经营主体',
          url: 'http://1.92.70.79:10014?redirect=/index&ssoUrl=http://117.159.15.238:18011',
          src: require('@/assets/images/xxjyzt.png'),
          backGround: require('@/assets/images/bg_xxjyzt.png'),
        },
        {
          name: '农票后台',
          url: 'http://1.92.70.79:10057?redirect=/index&ssoUrl=http://117.159.15.238:18011',
          src: require('@/assets/images/tdcbwq.png'),
          backGround: require('@/assets/images/bg_qqbg.png'),
        },
        {
          name: '农票质押',
          url: 'http://117.159.15.238:18018',
          src: require('@/assets/images/qqbg.png'),
          backGround: require('@/assets/images/bg_qqbg.png'),
        },
        {
          name: '预警监测',
          url: 'http://117.159.15.238:18013',
          src: require('@/assets/images/yjjc.png'),
          backGround: require('@/assets/images/bg_yjjc.png'),
        },
      ],
      showAppImage: true,
      appImage: require('@/assets/images/gangquAppImage.png'),
    },
    dev: {},
  },
}

/**
 * notShowCqjyDetail 不展示产权交易详情页
 */
module.exports = {
  cityOption: prefecturalList['濮阳县']['prod'],
}
